// helpBot.js
// ============================================
// Rule-based Help Assistant Knowledge Base (English + Bangla)
// AI command-er keyword gulo সরাসরি aiCommandEngine.js theke import kora hocche,
// tai oikhane notun keyword/command jog korle এখানে আলাদা করে লেখা লাগবে না।
// ============================================

import {
  ROW_WORDS, COLUMN_WORDS,
  OPERATOR_WORDS,
  ASC_WORDS, DESC_WORDS, SORT_WORDS,
  SEARCH_WORDS,
  COLOR_MAP,
  SERIAL_WORDS,
  REPLACE_WORDS,
  MERGE_WORDS,
  SPLIT_WORDS,
} from "./aiCommandEngine";

// Object-er key gulo (color/operator name) shudhu array te niye asa
const colorNames = Object.keys(COLOR_MAP).filter(k => /^[a-z]+$/.test(k)).slice(0, 6); // english name gulo dekhano jonno
const operatorNames = Object.values(OPERATOR_WORDS).map(arr => arr[0]);

export const HELP_KB = [
  {
    id: "create_table",
    category: "command",
    titleEn: "Create Table",
    titleBn: "টেবিল বানানো",
    keywords: [...ROW_WORDS, ...COLUMN_WORDS, "table create", "table banano", "টেবিল বানা", "ai generator", "new table"],
    answerEn: `Type into the AI Generator box (top of the sheet) something like: "Payroll 15 rows" or "10 rows 5 columns". You can also add column names: "column name Name, Age, Salary" and a color: "blue table". Click BUILD and your table appears instantly.`,
    answerBn: `শীটের উপরে AI Generator বক্সে লিখো, যেমন: "Payroll 15 rows" বা "১০টা সারি ৫টা কলাম"। কলামের নামও দিতে পারো: "column name Name, Age, Salary", আর রংও: "blue table"। BUILD এ ক্লিক করলেই টেবিল তৈরি হয়ে যাবে।`,
  },
  {
    id: "column_math",
    category: "command",
    titleEn: "Column Math (add/subtract/multiply/divide)",
    titleBn: "কলাম দিয়ে হিসাব (যোগ/বিয়োগ/গুণ/ভাগ)",
    keywords: [...operatorNames, "column math", "calculate columns", "sum two columns"],
    answerEn: `Type a command naming both columns and the operation, e.g. "Price Quantity ${operatorNames[2]}" (multiply) or "Salary Bonus ${operatorNames[0]}" (add). You can also name the result column: "result column Total". A new calculated column will be added.`,
    answerBn: `দুইটা কলামের নাম আর অপারেশন লিখে দাও, যেমন: "Price Quantity ${operatorNames[2]}" (গুণ) বা "Salary Bonus ${operatorNames[0]}" (যোগ)। ফলাফলের কলামের নামও দিতে পারো: "result column Total"। নতুন হিসাব করা কলাম যোগ হয়ে যাবে।`,
  },
  {
    id: "sort",
    category: "command",
    titleEn: "Sort a Column",
    titleBn: "কলাম সাজানো (Sort)",
    keywords: [...SORT_WORDS, ...ASC_WORDS, ...DESC_WORDS],
    answerEn: `Type "sort ColumnName ascending" or "ColumnName descending soro" — replace ColumnName with your actual column name. Works in both English and Bangla.`,
    answerBn: `লিখো "sort ColumnName ascending" বা "ColumnName descending soro" — ColumnName এর জায়গায় আসল কলামের নাম বসাও। বাংলা আর ইংরেজি দুটোতেই কাজ করে।`,
  },
  {
    id: "search_filter",
    category: "command",
    titleEn: "Search / Filter Rows",
    titleBn: "খুঁজো / ফিল্টার",
    keywords: [...SEARCH_WORDS, "find row"],
    answerEn: `Type "khujo Rice" or "search John" — it finds and jumps to the matching cell/row instantly. No need to scroll manually.`,
    answerBn: `লিখো "khujo Rice" বা "search John" — সাথে সাথে সেই সেল/সারিতে জাম্প করবে। হাতে স্ক্রল করার দরকার নেই।`,
  },
  {
    id: "color_command",
    category: "command",
    titleEn: "Color a Column/Row",
    titleBn: "কলাম/রো রং করা",
    keywords: [...colorNames, "color", "রং", "রঙ", "column color", "row color", "cell color"],
    answerEn: `Type something like "column 2 color blue, row 5 color green" — you can combine multiple instructions with a comma. Supports color names in English and Bangla (${colorNames.slice(0,3).join(", ")}, etc).`,
    answerBn: `লিখো "column 2 color blue, row 5 color green" — কমা দিয়ে একাধিক নির্দেশও দেওয়া যায়। বাংলা-ইংরেজি দুই ভাষার রঙের নামই কাজ করে (lal/লাল, nil/নীল, sobuj/সবুজ ইত্যাদি)।`,
  },
  {
    id: "auto_serial",
    category: "command",
    titleEn: "Auto Serial Number",
    titleBn: "অটো সিরিয়াল নম্বর",
    keywords: [...SERIAL_WORDS],
    answerEn: `Type "auto number ColumnName" or "ColumnName serial" — it fills that column with 1, 2, 3... automatically for every row.`,
    answerBn: `লিখো "auto number ColumnName" বা "ColumnName সিরিয়াল" — এটা সেই কলামে প্রতিটা সারিতে ১, ২, ৩... নম্বর বসিয়ে দিবে।`,
  },
  {
    id: "find_replace",
    category: "command",
    titleEn: "Find & Replace",
    titleBn: "খুঁজে বদলানো (Find & Replace)",
    keywords: [...REPLACE_WORDS, "find replace"],
    answerEn: `Type something like 'replace "old text" with "new text"' (use quotes) — it swaps every matching value, optionally within one column if you name it.`,
    answerBn: `লিখো 'replace "পুরনো টেক্সট" with "নতুন টেক্সট"' (quote সহ) — এটা সব মিলে যাওয়া value বদলে দিবে, চাইলে নির্দিষ্ট একটা কলামের নামও বলে দিতে পারো।`,
  },
  {
    id: "merge_columns",
    category: "command",
    titleEn: "Merge Two Columns",
    titleBn: "দুই কলাম একত্র করা (Merge)",
    keywords: [...MERGE_WORDS],
    answerEn: `Type "First Name Last Name merge Full Name banao" — this combines two named columns into a new column with the name you give.`,
    answerBn: `লিখো "First Name Last Name merge Full Name banao" — এটা দুইটা কলাম একত্র করে তুমি যে নাম দিবে সেই নামে নতুন কলাম বানাবে।`,
  },
  {
    id: "split_column",
    category: "command",
    titleEn: "Split a Column",
    titleBn: "কলাম ভাগ করা (Split)",
    keywords: [...SPLIT_WORDS],
    answerEn: `Type "ColumnName split koro" — it splits that column's values by space (or say "comma" to split by comma instead).`,
    answerBn: `লিখো "ColumnName split koro" — এটা সেই কলামের ভ্যালুগুলো space দিয়ে ভাগ করবে (কমা দিয়ে ভাগ করতে চাইলে "comma" বলে দাও)।`,
  },
  {
    id: "sticky_note",
    keywords: ["sticky note", "note", "নোট", "pin", "📌", "comment on cell"],
    answerEn: `Hover over any cell in a shared table — a small 📌 icon appears. Click it to write a note. Everyone with access to that table sees it in real time. Click the 📌 counter icon near the tab to see all notes and jump to any of them.`,
    answerBn: `শেয়ার করা টেবিলের যেকোনো সেলে hover করলে ছোট 📌 আইকন আসবে। ক্লিক করে নোট লেখো। ওই টেবিলে যাদের access আছে তারা সবাই real-time দেখবে। ট্যাবের পাশের 📌 আইকনে ক্লিক করলে সব নোটের তালিকা দেখা যাবে, ক্লিক করলে সেই সেলে জাম্প করবে।`,
  },
  {
    id: "team_chat",
    keywords: ["chat", "চ্যাট", "team chat", "message", "মেসেজ"],
    answerEn: `Click the 💬 icon next to a shared table's tab to open the chat box. Anyone with access to that table can send messages in real time. You can drag the box by its header, react with emoji, delete your own messages, and mute notification sounds with the 🔔 icon.`,
    answerBn: `শেয়ার করা টেবিলের ট্যাবের পাশে 💬 আইকনে ক্লিক করলে চ্যাট বক্স খুলবে। যাদের access আছে তারা real-time মেসেজ পাঠাতে পারবে। বক্সের header ধরে টেনে সরানো যায়, emoji react করা যায়, নিজের মেসেজ ডিলিট করা যায়, আর 🔔 আইকনে ক্লিক করে সাউন্ড mute করা যায়।`,
  },
  {
    id: "share",
    keywords: ["share", "শেয়ার", "collaborate", "team edit", "invite"],
    answerEn: `Click the SHARE button in the toolbar. This generates a shareable link — anyone who opens it and logs in can view or edit the table live, together with you.`,
    answerBn: `টুলবারের SHARE বাটনে ক্লিক করো। এটা একটা শেয়ারযোগ্য লিংক তৈরি করবে — যে কেউ সেই লিংক খুলে লগইন করলে লাইভ একসাথে টেবিল দেখতে/এডিট করতে পারবে।`,
  },
  {
    id: "export",
    keywords: ["excel", "export", "download", "pdf", "এক্সপোর্ট", "ডাউনলোড"],
    answerEn: `Use the EXCEL or PDF buttons in the toolbar to download your current sheet in that format, ready to share or print.`,
    answerBn: `টুলবারের EXCEL বা PDF বাটন ব্যবহার করে বর্তমান শীট সেই ফরম্যাটে ডাউনলোড করো, শেয়ার বা প্রিন্ট করার জন্য রেডি।`,
  },
  {
    id: "freeze",
    keywords: ["freeze", "ফ্রিজ", "lock column", "sticky column"],
    answerEn: `The Freeze dropdown locks the first N columns in place so they stay visible while you scroll right through a wide table.`,
    answerBn: `Freeze ড্রপডাউন প্রথম কয়েকটা কলাম লক করে রাখে, যাতে ডানদিকে স্ক্রল করার সময়ও সেগুলো দেখা যায়।`,
  },
  {
    id: "vault_history",
    keywords: ["vault", "history", "save table", "backup", "সেভ", "restore"],
    answerEn: `Vault History (right sidebar) stores saved snapshots of your sheet. Press SAVE to store the current state — you can restore any saved version later if you need to undo bigger changes.`,
    answerBn: `Vault History (ডানপাশের সাইডবার) শীটের সেভ করা ভার্সন জমা রাখে। SAVE চাপলে বর্তমান অবস্থা সেভ হবে — পরে বড় কোনো ভুল হলে আগের ভার্সনে ফিরে যাওয়া যাবে।`,
  },
  {
    id: "templates",
    keywords: ["template", "টেমপ্লেট", "quick start", "ready made"],
    answerEn: `TEMPLATES gives you ready-made table structures (like inventory, payroll, or student lists) so you can start filling data immediately instead of building a table from scratch.`,
    answerBn: `TEMPLATES এ রেডিমেড টেবিল স্ট্রাকচার (যেমন ইনভেন্টরি, পে-রোল, স্টুডেন্ট লিস্ট) পাওয়া যায়, যাতে শুরু থেকে না বানিয়ে সরাসরি ডেটা ভরা শুরু করা যায়।`,
  },
  {
    id: "payment",
    keywords: ["upgrade", "pro", "payment", "পেমেন্ট", "টাকা", "subscription", "price", "cost"],
    answerEn: `Click UPGRADE in the toolbar to see Pro plans. If you already paid and have an issue, use the "Payment Support" button inside the upgrade window to message us directly — we usually reply within 24 hours.`,
    answerBn: `টুলবারের UPGRADE বাটনে ক্লিক করে Pro প্ল্যান দেখো। আগে থেকে পেমেন্ট করে থাকলে আর কোনো সমস্যা হলে, upgrade উইন্ডোর ভেতরের "Payment Support" বাটন দিয়ে সরাসরি মেসেজ পাঠাও — সাধারণত ২৪ ঘণ্টার মধ্যে রিপ্লাই দেওয়া হয়।`,
  },
  {
    id: "support",
    keywords: ["support", "help", "contact", "সাহায্য", "যোগাযোগ", "problem", "bug"],
    answerEn: `Click the floating 💬 button at the bottom-right of the screen anytime to send us a message directly — it reaches our team by email.`,
    answerBn: `স্ক্রিনের নিচে-ডানে ফ্লোটিং 💬 বাটনে ক্লিক করে যেকোনো সময় সরাসরি মেসেজ পাঠাও — এটা সরাসরি আমাদের টিমের ইমেইলে পৌঁছায়।`,
  },
  {
    id: "save_button",
    titleEn: "Save Button",
    titleBn: "Save বাটন",
    keywords: ["save button", "সেভ বাটন", "how to save"],
    answerEn: `The SAVE button (top toolbar) stores a snapshot of your current sheet into Vault History (right sidebar), so you can restore it later if needed.`,
    answerBn: `উপরের SAVE বাটন তোমার বর্তমান শীটের একটা কপি Vault History-তে (ডানপাশের সাইডবার) জমা রাখে, পরে দরকার হলে ফিরিয়ে আনা যায়।`,
  },
  {
    id: "excel_pdf_button",
    titleEn: "Excel / PDF Buttons",
    titleBn: "Excel / PDF বাটন",
    keywords: ["excel button", "pdf button", "download excel", "download pdf", "এক্সেল বাটন", "পিডিএফ বাটন"],
    answerEn: `EXCEL and PDF buttons (top toolbar) instantly download your current sheet in that file format.`,
    answerBn: `উপরের EXCEL আর PDF বাটন তোমার বর্তমান শীট সাথে সাথে সেই ফরম্যাটে ডাউনলোড করে দেয়।`,
  },
  {
    id: "import_button",
    titleEn: "Import Button",
    titleBn: "Import বাটন",
    keywords: ["import button", "ইম্পোর্ট বাটন", "upload excel", "upload csv"],
    answerEn: `The IMPORT button lets you upload an existing Excel or CSV file — it loads that data straight into a new sheet.`,
    answerBn: `IMPORT বাটন দিয়ে আগে থেকে থাকা Excel বা CSV ফাইল আপলোড করা যায় — সাথে সাথে নতুন শীটে ডেটা চলে আসবে।`,
  },
  {
    id: "print_button",
    titleEn: "Print Button",
    titleBn: "Print বাটন",
    keywords: ["print button", "প্রিন্ট বাটন", "print sheet"],
    answerEn: `The PRINT button opens your sheet in a print-ready layout so you can print it directly from the browser.`,
    answerBn: `PRINT বাটন তোমার শীট প্রিন্ট-উপযোগী লেআউটে খুলে দেয়, সরাসরি ব্রাউজার থেকে প্রিন্ট করা যায়।`,
  },
  {
    id: "hide_empty",
    titleEn: "Hide Empty",
    titleBn: "Hide Empty",
    keywords: ["hide empty", "hide empty rows", "ফাঁকা লুকানো"],
    answerEn: `HIDE EMPTY temporarily hides all fully empty rows/columns in view, so you can focus on filled data.`,
    answerBn: `HIDE EMPTY সব ফাঁকা সারি/কলাম সাময়িকভাবে লুকিয়ে দেয়, শুধু ভরা ডেটা দেখা যায়।`,
  },
  {
    id: "ai_table_button",
    titleEn: "AI Table Button",
    titleBn: "AI Table বাটন",
    keywords: ["ai table button", "ai table generator", "table generator"],
    answerEn: `The AI TABLE button opens a bigger AI generator window for building more complex or bulk tables in one go.`,
    answerBn: `AI TABLE বাটন একটা বড় জেনারেটর উইন্ডো খুলে দেয়, একসাথে বড় বা জটিল টেবিল বানানোর জন্য।`,
  },
  {
    id: "theme_toggle",
    titleEn: "Dark/Light Mode Toggle",
    titleBn: "থিম বদলানো (ডার্ক/লাইট)",
    keywords: ["dark mode", "light mode", "theme", "থিম", "ডার্ক মোড"],
    answerEn: `The moon/sun icon in the toolbar switches between dark and light mode.`,
    answerBn: `টুলবারের চাঁদ/সূর্য আইকনে ক্লিক করলে ডার্ক আর লাইট মোডের মধ্যে বদলানো যায়।`,
  },
  {
    id: "duplicate_tab",
    titleEn: "Duplicate Table",
    titleBn: "টেবিল ডুপ্লিকেট করা",
    keywords: ["duplicate table", "copy table", "টেবিল কপি", "ডুপ্লিকেট"],
    answerEn: `Right-click or use the duplicate icon on a sheet tab to make a full copy of that table as a new tab.`,
    answerBn: `শীট ট্যাবের duplicate আইকনে ক্লিক করলে সেই টেবিলের সম্পূর্ণ কপি নতুন ট্যাবে তৈরি হয়ে যাবে।`,
  },
  {
    id: "insert_row_col",
    titleEn: "Insert Row / Column (+R / +C)",
    titleBn: "সারি/কলাম যোগ করা (+R / +C)",
    keywords: ["insert row", "insert column", "+r", "+c", "সারি যোগ", "কলাম যোগ", "add row", "add column"],
    answerEn: `The +R and +C buttons in the formatting toolbar add a new row or column right where your cursor is.`,
    answerBn: `ফরম্যাটিং টুলবারের +R আর +C বাটন কার্সারের জায়গায় নতুন সারি বা কলাম যোগ করে।`,
  },
  {
    id: "auto_number_icon",
    titleEn: "Auto Number (№)",
    titleBn: "অটো নম্বর (№)",
    keywords: ["№", "auto number icon"],
    answerEn: `The № icon in the formatting toolbar fills the selected column with sequential numbers (1, 2, 3...) automatically.`,
    answerBn: `ফরম্যাটিং টুলবারের № আইকন সিলেক্ট করা কলামে ক্রমিক নম্বর (১, ২, ৩...) বসিয়ে দেয়।`,
  },
  {
    id: "clean_remove_empty",
    titleEn: "Clean Spaces / Remove Empty Rows",
    titleBn: "ফাঁকা স্পেস/সারি পরিষ্কার করা",
    keywords: ["clean spaces", "remove empty rows", "ফাঁকা সারি মুছে", "clean data"],
    answerEn: `The ⌥ icon trims extra spaces from text, and ✕R removes any fully empty rows from the table.`,
    answerBn: `⌥ আইকন লেখা থেকে অতিরিক্ত স্পেস মুছে দেয়, আর ✕R সম্পূর্ণ ফাঁকা সারিগুলো মুছে ফেলে।`,
  },
  {
    id: "conditions",
    titleEn: "Conditional Formatting",
    titleBn: "শর্তসাপেক্ষ ফরম্যাটিং (Conditions)",
    keywords: ["conditions", "conditional formatting", "শর্ত", "rules"],
    answerEn: `The Conditions button lets you set rules like "highlight cell red if value < 100" — formatting updates automatically as data changes.`,
    answerBn: `Conditions বাটন দিয়ে নিয়ম বানানো যায় (যেমন "মান ১০০-এর কম হলে লাল করো") — ডেটা বদলালে ফরম্যাটও নিজে নিজে আপডেট হয়।`,
  },
  {
    id: "search_records",
    titleEn: "Search Records Box",
    titleBn: "Search Records বক্স",
    keywords: ["search records", "সার্চ বক্স"],
    answerEn: `The 🔍 Search records box (above the table) filters rows live as you type, matching any column.`,
    answerBn: `টেবিলের উপরের 🔍 Search records বক্সে টাইপ করলে সাথে সাথে মিলে যাওয়া সারিগুলো দেখাবে, যেকোনো কলামে খুঁজবে।`,
  },
  {
    id: "cell_formatting",
    titleEn: "Bold / Italic / Number Format",
    titleBn: "বোল্ড / ইটালিক / সংখ্যা ফরম্যাট",
    keywords: ["bold", "italic", "number format", "বোল্ড", "ইটালিক"],
    answerEn: `The formatting toolbar has Bold (B), Italic (I), and Number Format options for styling selected cells, just like Excel.`,
    answerBn: `ফরম্যাটিং টুলবারে Bold (B), Italic (I), আর Number Format আছে সিলেক্ট করা সেল স্টাইল করার জন্য, ঠিক Excel-এর মতো।`,
  },
  {
    id: "calc_engine_box",
    titleEn: "Formula/Sort/Search Box (Calculation Engine)",
    titleBn: "Formula/Sort/Search বক্স (হিসাব ইঞ্জিন)",
    keywords: ["formula box", "calculation", "হিসাব বক্স", "calc engine", "average", "গড়", "total", "টোটাল", "max", "min", "সর্বোচ্চ", "সর্বনিম্ন", "khali cell", "empty cell", "খালি সেল", "add as column", "add total row"],
    answerEn: `The "Formula, sort, or search..." box (above the table) does live calculations as you type — no Enter needed. Try "Price average", "Salary total", or "Price Qty gun" (multiply) to see instant results, with buttons to save it as a new column or a total row. Press Enter with a sort or search command to run those instead. Typing "khali cell" highlights empty cells; "hide empty" turns it off.`,
    answerBn: `"Formula, sort, or search..." বক্সে (টেবিলের উপরে) টাইপ করামাত্রই হিসাব দেখা যায়, Enter লাগে না। যেমন "Price average", "Salary total", বা "Price Qty gun" (গুণ) লিখলে সাথে সাথে ফলাফল দেখাবে, সাথে সেটা নতুন কলাম বা Total সারি হিসেবে সেভ করার বাটনও আসে। Sort বা Search কমান্ডের ক্ষেত্রে Enter চাপতে হয়। "khali cell" লিখলে ফাঁকা সেল হাইলাইট হবে, "hide empty" লিখলে বন্ধ হবে।`,
  },
  {
    id: "list_commands",
    keywords: ["shob command", "সব কমান্ড", "কি কি করা যায়", "কমান্ড লিস্ট", "কমান্ড তালিকা", "all commands", "list commands", "guide", "সব ফিচার", "what can i do", "which box", "everything", "সব কিছু", "how does this site work"],
    answerEn: null, // dynamically generated below
    answerBn: null,
  },
];

// ============================================
// Language detection (Bangla vs English)
// ============================================
function isBangla(text) {
  return /[\u0980-\u09FF]/.test(text);
}

// ============================================
// Simple keyword-overlap matcher
// ============================================
// ====== সব কমান্ডের তালিকা স্বয়ংক্রিয়ভাবে তৈরি করো ======
function buildCommandList(isBn) {
  const commandEntries = HELP_KB.filter(e => e.titleEn && e.titleBn);
  const lines = commandEntries.map(e => {
    const title = isBn ? e.titleBn : e.titleEn;
    return `• ${title}`;
  });
  const header = isBn
    ? "এই সাইটে AI Command Box-এ এই কমান্ডগুলো ব্যবহার করা যায়:\n\n"
    : "In this site's AI Command Box, you can use these commands:\n\n";
  const footer = isBn
    ? "\n\nযেকোনো একটার নাম বললে (যেমন \"sort কিভাবে\") আমি বিস্তারিত বলে দিব।"
    : "\n\nAsk about any one by name (e.g. \"how does sort work\") for more detail.";
  return header + lines.join("\n") + footer;
}

export function matchHelpQuestion(query) {
  const text = (query || "").toLowerCase().trim();
  if (!text) return null;
  const isBn = isBangla(query);

  let bestEntry = null;
  let bestScore = 0;

  for (const entry of HELP_KB) {
    let score = 0;
    for (const kw of entry.keywords) {
      if (!kw) continue;
      if (text.includes(String(kw).toLowerCase())) score += String(kw).length;
    }
    if (score > bestScore) {
      bestScore = score;
      bestEntry = entry;
    }
  }

  if (bestEntry && bestScore > 0) {
    // list_commands entry hole dynamically list banao
    if (bestEntry.id === "list_commands") return buildCommandList(isBn);
    return isBn ? bestEntry.answerBn : bestEntry.answerEn;
  }
  return null;
}

export const HELP_SUGGESTIONS = [
  { en: "How do I create a new table with AI?", bn: "AI দিয়ে নতুন টেবিল কিভাবে বানাবো?" },
  { en: "How do I sort a column?", bn: "কলাম কিভাবে সাজাবো (sort)?" },
  { en: "How do sticky notes work?", bn: "Sticky Note কিভাবে কাজ করে?" },
  { en: "How do I share a table with my team?", bn: "টিমের সাথে টেবিল কিভাবে শেয়ার করবো?" },
];